// Building blocks for sharing a job: the preview link, the share text, and the per-app URLs.
// Used by the employer's share screen (after posting + on the dashboard). All links point at the
// backend share page (/api/jobs/<slug>/share), which carries the Open Graph tags that give a
// proper preview card in Facebook, Messenger and Viber.
import config from '../config';

// Same Facebook app id the job page's share dialog uses.
const FB_APP_ID = '1387027799794224';

export function jobShareLink(job) {
  const key = job?.slug || job?.id;
  return key ? `${config.BACKEND_URL}/api/jobs/${encodeURIComponent(key)}/share` : '';
}

function peso(n) {
  const v = Number(n);
  return Number.isFinite(v) && v > 0 ? `₱${v.toLocaleString('en-PH')}` : '';
}

// "Hiring 100 · Call Center Agent in Tagbilaran — ₱16,000–₱19,000 | Apply now on Bohol Trabaho!"
export function jobShareText(job) {
  if (!job) return '';
  const openings = parseInt(job.positions_available, 10);
  const hiring = Number.isFinite(openings) && openings > 1 ? `Hiring ${openings} · ` : '';
  const where = (Array.isArray(job.locations) && job.locations.length ? job.locations : [job.location])
    .filter(Boolean).join(', ');
  const min = peso(job.salary_min);
  const max = peso(job.salary_max);
  const pay = min && max ? `${min}–${max}` : (min || max);
  return `${hiring}${job.title || 'Job opening'}${where ? ` in ${where}` : ''}${pay ? ` — ${pay}` : ''} | Apply now on Bohol Trabaho!`;
}

export function facebookShareUrl(link) {
  return `https://www.facebook.com/dialog/share?app_id=${FB_APP_ID}&display=popup&href=${encodeURIComponent(link)}&redirect_uri=${encodeURIComponent(link)}`;
}

export function messengerShareUrl(link) {
  return `fb-messenger://share/?link=${encodeURIComponent(link)}`;
}

export function viberShareUrl(text, link) {
  return `viber://forward?text=${encodeURIComponent(`${text} ${link}`)}`;
}
